const reporteDeDireccion = {
    ObtenerReporteDeDireccion: 'SINOJ/ReporteDeDireccion/ObtenerReporteDeDireccionV2',
    ObtenerCedulasDeSolicitudDeReporte: 'SINOJ/ReporteDeDireccion/ObtenerCedulasDeSolicitudDeReporte',
    ObtenerReporteCedulasEnviadasPorRangoDeFechas: 'SINOJ/ReporteDeDireccion/ObtenerReporteCedulasEnviadasPorRangoDeFechas'
}

const reporteDeJuzgado = {
    ObtenerReporteDeJuzgado: 'SINOJ/ReporteDeJuzgado/ObtenerReporteDeJuzgadoV2',
    ObtenerCedulasDeSolicitudDeReporte: 'SINOJ/ReporteDeJuzgado/ObtenerCedulasDeSolicitudDeReporte',
    ObtenerCedulasCreadasEnJuzgado: 'SINOJ/ReporteDeJuzgado/ObtenerCedulasCreadasEnJuzgado',
    ObtenerReporteDeCedulasCreadasJuzgado: 'SINOJ/ReporteDeJuzgado/ObtenerReporteCedulasCreadasEnJuzgadoV2'
}

const reporteDeNotificador = {
    ObtenerCedulasReporteDeNotificador: 'SINOJ/ReporteDeNotificador/ObtenerCedulasReporteDeNotificador',
    ObtenerReporteDeNotificador: 'SINOJ/ReporteDeNotificador/ObtenerReporteDeNotificadorV2'
}

const reporteAsignacionesNotificadores = {
    ObtenerReporteDeCedulasAsignadas: 'SINOJ/ReporteAsignacionesNotificadores/ObtenerReporteDeCedulasAsignadas',
    ObtenerReporteDeAsignacionesNotificadores: 'SINOJ/ReporteAsignacionesNotificadores/ObtenerReporteDeAsignacionesNotificadoresV2',
    ObtenerReporteCedulasPendientesNotificador: 'SINOJ/ReporteAsignacionesNotificadores/ObtenerReporteCedulasPendientesNotificador'
}

const reportes = {
    reporteDeDireccion: reporteDeDireccion,
    reporteDeJuzgado: reporteDeJuzgado,
    reporteDeNotificador: reporteDeNotificador,
    reporteAsignacionesNotificadores: reporteAsignacionesNotificadores
}

export default reportes;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/sistema/Reportes/Reportes.js
// module id = null
// module chunks = 